import { render, staticRenderFns } from "./WorkforceHome.vue?vue&type=template&id=7fe80b66&"
import script from "./WorkforceHome.vue?vue&type=script&lang=js&"
export * from "./WorkforceHome.vue?vue&type=script&lang=js&"
import style0 from "./WorkforceHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports